export interface OtherUserInfo {
  name?: string;
  image?: string;
  account_status?: string;
  correspondingUserAccountId?: string;
  correspondingUserId?: string;
  providerType?: string;
  showMessageHistory: boolean;
  showTrustSafetyBanner: boolean;
  bannerMessage?: string;
  showAvatar: boolean;
  showDate: boolean;
  accountClosed: boolean;
}

interface ChannelMemberMeta {
  account_status?: string;
  account_id?: string;
  provider_type?: string;
  providerType?: string;
}

interface ChannelMember {
  userId?: string;
  nickname?: string;
  plainProfileUrl?: string;
  metaData?: ChannelMemberMeta;
}

// Account status constants for hiding message history and profile
const CLOSED_ACCOUNT_STATUSES = ['closed1', 'closed2', 'closed3'];

// Account status constants for showing trust/safety banner
const INACTIVE_ACCOUNT_STATUSES = [...CLOSED_ACCOUNT_STATUSES, 'closed', 'frozen'];

const bannerMessages: Record<string, string> = {
  closed: "This user can't be contacted because their Sittercity account is inactive.",
  frozen: "This user can't be contacted because their Sittercity account is inactive.",
  closed1: 'This user is no longer a member of the Sittercity network.',
  closed2: 'This user is no longer a member of the Sittercity network.',
  closed3: 'This user has been removed from the Sittercity network. Check your email for additional information.',
};

const isClosedAccountStatus = (status?: string): boolean => CLOSED_ACCOUNT_STATUSES.includes(status || '');
const isInactiveAccountStatus = (status?: string): boolean => INACTIVE_ACCOUNT_STATUSES.includes(status || '');

export const getOtherUserInformation = (members: ChannelMember[] = [], userId?: string): OtherUserInfo => {
  const info: OtherUserInfo = {
    showMessageHistory: true,
    showTrustSafetyBanner: false,
    bannerMessage: '',
    showAvatar: true,
    showDate: true,
    accountClosed: false,
  };

  members.forEach((member) => {
    if (member.userId && member.userId !== userId) {
      const status = member.metaData?.account_status;
      info.name = member.nickname;
      info.image = member.plainProfileUrl;
      info.account_status = status;
      info.correspondingUserAccountId = member.metaData?.account_id;
      info.correspondingUserId = member.userId;
      info.providerType = member.metaData?.provider_type || member.metaData?.providerType;

      if (isClosedAccountStatus(status)) {
        info.showMessageHistory = false;
        info.showAvatar = false;
      }

      if (isInactiveAccountStatus(status)) {
        info.showTrustSafetyBanner = true;
        info.bannerMessage = bannerMessages[status || ''] || '';
        info.showDate = false;
        info.accountClosed = true;
      }
    }
  });

  return info;
};
